import gql from 'graphql-tag';

const contractPortalUserProfileFields = `
  userProfileId
  userLoginId
  firstName
  lastName
  name
  emailAddress
`;

const contractPortalUserFields = `
  userLoginId
  usersId
  name
  username
  emailAddress
  link
  isLinked
`;

const contractPortalLinkHistoryFields = `
  contractNumber
  link
  createdAt
`;

export const searchPortalUserProfilesQuery = gql`
  query SearchPortalUserProfiles($email: String!, $azureUserId: String) {
    searchPortalUserProfiles(email: $email, azureUserId: $azureUserId) {
      items {
        ${contractPortalUserProfileFields}
      }
      count
    }
  }
`;

export const getLinkedContractPortalUsersQuery = gql`
  query GetLinkedContractPortalUsers($contractNumber: String!, $azureUserId: String) {
    getLinkedContractPortalUsers(contractNumber: $contractNumber, azureUserId: $azureUserId) {
      items {
        ${contractPortalUserFields}
      }
      count
    }
  }
`;

export const getContractPortalUsersAssociationStatusQuery = gql`
  query GetContractPortalUsersAssociationStatus($contractNumber: String!, $azureUserId: String) {
    getContractPortalUsersAssociationStatus(
      contractNumber: $contractNumber
      azureUserId: $azureUserId
    ) {
      contractNumber
      associated
      canLink
      message
      linkedUsers {
        userLoginId
        name
        username
        emailAddress
        link
        isLinked
      }
    }
  }
`;

export const getUserProfileTabEligibilityQuery = gql`
  query GetUserProfileTabEligibility($azureUserId: String!) {
    getUserProfileTabEligibility(azureUserId: $azureUserId)
  }
`;

export const getPortalUserProfileContractHistoryQuery = gql`
  query GetPortalUserProfileContractHistory(
    $userLoginId: Int
    $email: String
    $azureUserId: String
  ) {
    getPortalUserProfileContractHistory(
      userLoginId: $userLoginId
      email: $email
      azureUserId: $azureUserId
    ) {
      items {
        ${contractPortalLinkHistoryFields}
      }
      count
    }
  }
`;
